import { api } from "@/services/api"
import type { ListNotificationsResponseItem } from "./listNotifications"
import { queryClient } from "@/queryClient"

export const deleteNotification = async (
  notificationId: ListNotificationsResponseItem["id"]
) => {
  await api.delete(`/notifications/${notificationId}`)

  queryClient.invalidateQueries([
    BASE_NOTIFICATIONS_QUERY_KEY,
  ])
}
